import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { bambooDictVi } from "@/lib/shop/products/bamboo";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/vi/shop_/bamboo")({
  head: () => ({
    ...buildProductHead(bambooDictVi),
    links: alternateLinkList("/shop/bamboo", "vi"),
  }),
  component: () => <ProductPage dict={bambooDictVi} />,
});